import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sne-overlay"
}
const _hoisted_2 = {
  class: "sne-box",
  role: "alertdialog",
  "aria-live": "assertive",
  "aria-label": "Adiamento chegou ao limite"
}
const _hoisted_3 = { class: "sne-desc" }
const _hoisted_4 = {
  key: 0,
  class: "sne-more"
}
const _hoisted_5 = { class: "sne-actions" }

import { computed } from 'vue'
import { pendingSnoozeAlerts, dismissCurrentSnoozeAlert } from '@/composables/useSnoozeAlerts'
import { requestOpenChat } from '@/composables/useChatTrigger'


export default /*@__PURE__*/_defineComponent({
  __name: 'SnoozeEndedModal',
  setup(__props) {

// Mesmo formato do popup "Novo atendimento atribuído" (AssignmentAlertModal.vue): um aviso por vez, bloqueante.
const current = computed(() => pendingSnoozeAlerts.value[0] ?? null)

const untilLabel = computed(() => {
  if (!current.value) return ''
  const d = new Date(current.value.snoozedUntil)
  const sameDay = d.toDateString() === new Date().toDateString()
  return d.toLocaleString('pt-BR', sameDay ? { hour: '2-digit', minute: '2-digit' } : { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
})

function handleOpen() {
  if (!current.value) return
  requestOpenChat(current.value.conversationId)
  dismissCurrentSnoozeAlert()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "sne-fade" }, {
      default: _withCtx(() => [
        (current.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[6] || (_cache[6] = _createElementVNode("div", {
                  class: "sne-icon",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("svg", {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "13",
                      r: "8"
                    }),
                    _createElementVNode("path", { d: "M12 9v4l2 2M5 3 2 6M22 6l-3-3" })
                  ])
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sne-title" }, "Adiamento chegou ao limite", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _cache[1] || (_cache[1] = _createTextVNode(" A conversa com ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(current.value.contactName || 'o contato'), 1),
                  _cache[2] || (_cache[2] = _createTextVNode(" estava adiada até ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(untilLabel.value), 1),
                  _cache[3] || (_cache[3] = _createTextVNode(". Ela voltou pra ", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("b", null, "Aberta", -1)),
                  _cache[5] || (_cache[5] = _createTextVNode(". ", -1))
                ]),
                (_unref(pendingSnoozeAlerts).length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "+" + _toDisplayString(_unref(pendingSnoozeAlerts).length - 1) + " adiamento(s) vencido(s) na fila", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "sne-btn sne-btn--primary",
                    onClick: handleOpen
                  }, "Ir para a conversa"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "sne-btn sne-btn--secondary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dismissCurrentSnoozeAlert) && _unref(dismissCurrentSnoozeAlert)(...args)))
                  }, "Dispensar")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})